// extracted by mini-css-extract-plugin
export default {"tableItem":"TableItem_tableItem__yQOd4","btns":"TableItem_btns__uIDs5"};